import ftaLogo from "@/assets/fta-logo.png";
import uaeEagleLogo from "@/assets/uae-eagle-logo.png";
import { useTenantConfig } from "@/hooks/useTenantConfig";
import { getBaseUrl } from "@/utils/basePath";

export const PortalHeader = ({text,description}) => {
  const { mergedConfig } = useTenantConfig();
  const companyLogo = mergedConfig.logo;
  const companyName = mergedConfig.name;

  return (
    <header className="bg-card border-b border-border">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src={companyLogo} 
              alt={companyName} 
              className="h-12 object-contain"
              onError={(e) => {
                e.currentTarget.src = `${getBaseUrl()}tenants/taxilla/logo.png`;
              }}
            />
          </div>


          
          <div className="flex items-center gap-4">
            <img 
              src={ftaLogo} 
              alt="Federal Tax Authority" 
              className="h-12 object-contain"
            />
            <img 
              src={uaeEagleLogo} 
              alt="UAE Government" 
              className="h-12 object-contain"
            />
          </div>
        </div>
        
        <div className="mt-3">
          <h1 className="text-2xl font-bold text-navy">{text}</h1>
          <p>{description}</p>
        </div>
      </div>
    </header>
  );
};
